import { render } from "./HelpVdhPassword.vue?vue&type=template&id=60246c3d&scoped=true"
import script from "./HelpVdhPassword.vue?vue&type=script&lang=js"
export * from "./HelpVdhPassword.vue?vue&type=script&lang=js"

import "./HelpVdhPassword.vue?vue&type=style&index=0&id=60246c3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60246c3d"]])

export default __exports__